export default "__VITE_ASSET__D$DVhJsN__"